import DEFAULT_ROUTES from './routes';
import { PROJECT_NAV_COPY } from '../components/notifications/notification.constants';

const BASE = `${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.PROJECT}`;

// Route URL patterns for matchPath
// These patterns are used by RouteWatcher to sync URL with Redux state
const ROUTE_URLS = {
  PROJECTS: `${BASE}`,
  PROJECT_DETAIL: `${BASE}/:project_id`,
  TEST_CASES: `${BASE}/:project_id${DEFAULT_ROUTES.TEST_CASES}`,
  TEST_GROUPS: `${BASE}/:project_id${DEFAULT_ROUTES.TEST_GROUPS}`,
  AI_GENERATOR: `${BASE}/:project_id/ai-generator`,
  VARIABLES_ENV: `${BASE}/:project_id/variables-and-environment`,
  PROJECT_NOTIFICATION_PREFS: `${BASE}/:project_id${DEFAULT_ROUTES.PROJECT_NOTIFICATION_PREFS}`,
  PROJECT_SETTINGS: `${BASE}/:project_id${DEFAULT_ROUTES.PROJECT_SETTINGS}`,
  PROJECT_TEAM: `${BASE}/:project_id/users`,
  FILE_MANAGER: `${BASE}/:project_id${DEFAULT_ROUTES.FILE_MANAGER}`,
  // Automation Studio
  AUTOMATION_STUDIO: `${BASE}/:project_id/automation-studio`,
  AUTOMATION_STUDIO_TEST_CASE: `${BASE}/:project_id/automation-studio/:test_case_id`,
  AUTOMATION_STUDIO_NEW: `${BASE}/:project_id/automation-studio-new`,
  AUTOMATION_STUDIO_NEW_TEST_CASE: `${BASE}/:project_id/automation-studio-new/:test_case_id`,
  AUTOMATION_NEW: `${BASE}/:project_id${DEFAULT_ROUTES.AUTOMATION_NEW}`,
  // Admin / global
  USERS: `${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.USERS}`,
  ROLES: `${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.ROLES}`,
  ORGANIZATIONS: `${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.ORGANIZATIONS}`,
  CONFIGURATION: `${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.CONFIGURATION}`,
  PROFILE: `${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.PROFILE}`,
  REPORT_PORTAL: `${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.REPORT_PORTAL}`,
};

/**
 * Single source of truth: route pattern → sidebar page name.
 * Order matters: most specific routes first so the correct page name is chosen.
 * Used by RouteWatcher to sync URL to Redux activePage (DRY).
 */
export const ROUTE_TO_PAGE_NAME = [
  { pattern: ROUTE_URLS.AUTOMATION_STUDIO_NEW_TEST_CASE, pageName: 'Automation Studio' },
  { pattern: ROUTE_URLS.AUTOMATION_STUDIO_NEW, pageName: 'Automation Studio' },
  { pattern: ROUTE_URLS.AUTOMATION_STUDIO_TEST_CASE, pageName: 'Automation Studio' },
  { pattern: ROUTE_URLS.AUTOMATION_STUDIO, pageName: 'Automation Studio' },
  { pattern: ROUTE_URLS.AUTOMATION_NEW, pageName: 'Automation New' },
  { pattern: ROUTE_URLS.TEST_CASES, pageName: 'Test Cases' },
  { pattern: ROUTE_URLS.TEST_GROUPS, pageName: 'Test Groups' },
  { pattern: ROUTE_URLS.AI_GENERATOR, pageName: 'AI Generator' },
  { pattern: ROUTE_URLS.VARIABLES_ENV, pageName: 'Variables & Environment' },
  { pattern: ROUTE_URLS.PROJECT_NOTIFICATION_PREFS, pageName: PROJECT_NAV_COPY.projectNotification },
  { pattern: ROUTE_URLS.PROJECT_SETTINGS, pageName: PROJECT_NAV_COPY.projectSettings },
  { pattern: ROUTE_URLS.PROJECT_TEAM, pageName: 'Project Team' },
  { pattern: ROUTE_URLS.FILE_MANAGER, pageName: 'File Manager' },
  { pattern: ROUTE_URLS.PROJECTS, pageName: 'Projects' },
  { pattern: ROUTE_URLS.USERS, pageName: 'Users' },
  { pattern: ROUTE_URLS.ROLES, pageName: 'Roles' },
  { pattern: ROUTE_URLS.ORGANIZATIONS, pageName: 'Organizations' },
  { pattern: ROUTE_URLS.CONFIGURATION, pageName: 'Configuration' },
  { pattern: ROUTE_URLS.PROFILE, pageName: 'Profile' },
  { pattern: ROUTE_URLS.REPORT_PORTAL, pageName: 'Report Portal' },
];

export default ROUTE_URLS;
